import { createAction, props } from '@ngrx/store';
import { ISetupStatusResponse } from '../../../../../src/app/features/todos/models/setup-status.model';

import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';

export const loadLegalEntitiesForUserRequest = createAction('[LegalEntitiesForUser] Load LegalEntitiesForUser');

export const loadLegalEntitiesForUserSuccess = createAction(
  '[LegalEntitiesForUser] Load LegalEntitiesForUser Success',
  props<{ response: ISetupStatusResponse }>()
);

export const loadLegalEntitiesForUserFailure = createAction(
  '[LegalEntitiesForUser] Load LegalEntitiesForUser Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

export const clearLegalEntitiesForUserSuccess = createAction('[LegalEntitiesForUser] Clear LegalEntitiesForUser Success');
